import { FC, memo } from 'react';

import styles from './styles.module.css';
import { useMediaGridItem } from './use-media-grid-item';
import { FileType } from 'src/types';
import { MediaGridVideo } from './media-grid-video';
import { MediaGridImage } from './media-grid-image';

type Props = {
  data: FileType;
};

export const MediaGridItem: FC<Props> = memo(({ data }) => {
  const { isVideo, handleClick } = useMediaGridItem(data);

  if (!data || !data.type) {
    return;
  }

  const media = isVideo ? (
    <MediaGridVideo onClick={handleClick} src={data.url} />
  ) : (
    <MediaGridImage onClick={handleClick} src={data.url} />
  );

  return (
    <div className={styles.box}>
      <div className={styles.wrapper}>{media}</div>
    </div>
  );
});
